/**
 * Menu item configurations for desktop and mobile
 */
import {
	PATH_HOME,
	PATH_EMPLOYEE,
	PATH_APPLICANTS,
	PATH_TRAINING_COURSES,
	PATH_TRAINING_PARTICIPANTS,
	PATH_TRAINING_CERTIFICATIONS,
	PATH_TRAINING_SUMMARY,
	PATH_TRAINING_MASS_UPDATE,
	PATH_ASSET_SENTINEL_DASHBOARD,
	PATH_ASSET_SENTINEL_FLEET_VEHICLES,
	PATH_ASSET_SENTINEL_FLEET_WORK_ORDERS,
	PATH_ASSET_SENTINEL_FLEET_INSPECTION,
	PATH_ASSET_SENTINEL_FLEET_INSPECTION_SETUP,
	// PATH_ASSET_SENTINEL_FLEET_CODE_MAINTENANCE,
	PATH_ASSET_SENTINEL_EQUIPMENT,
	PATH_ASSET_SENTINEL_EQUIPMENT_MAINTENANCE,
	// PATH_ASSET_SENTINEL_EQUIPMENT_CODE_MAINTENANCE,
	PATH_ASSET_SENTINEL_EQUIPMENT_DISPENSABLE_ITEMS,
	PATH_ASSET_SENTINEL_EQUIPMENT_DASHBOARD,
	PATH_ASSET_SENTINEL_FLEET_DASHBOARD,
  PATH_ASSET_SENTINEL_EQUIPMENT_FUNDING_SOURCES,
  PATH_ASSET_SENTINEL_FLEET_FUNDING_SOURCES,
} from "../utils/routeConstants";

export const assetSentinelMenu = [
	{
		label: "Home",
		tooltip: "Home",
		link: PATH_ASSET_SENTINEL_DASHBOARD,
		icon: "home",
		alwaysVisible: true,
	},
	{
		label: "Fleet",
		tooltip: "Fleet",
		link: PATH_ASSET_SENTINEL_FLEET_DASHBOARD,
		icon: "truck",
		isAssetSentinelModule: true,
		permission: { area: "modules", key: "Fleet" },
		subMenu: [
			{
				label: "Dashboard",
				tooltip: "Dashboard",
				link: PATH_ASSET_SENTINEL_FLEET_DASHBOARD,
				icon: "home",
				alwaysVisible: true,
				// permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Fleet Vehicles",
				tooltip: "Fleet Vehicles",
				icon: "car",
				link: PATH_ASSET_SENTINEL_FLEET_VEHICLES,
				permission: { area: "fleet", key: "Vehicles" },
			},
			{
				label: "Work Orders",
				tooltip: "Work Orders",
				icon: "wrench",
				link: PATH_ASSET_SENTINEL_FLEET_WORK_ORDERS,
				permission: { area: "fleet", key: "Work Orders" },
			},
			{
				label: "Inspections",
				tooltip: "Inspections",
				icon: "check-circle",
				link: PATH_ASSET_SENTINEL_FLEET_INSPECTION,
				permission: { area: "fleet", key: "Inspections" },
			},
			{
				label: "Inspection Setup",
				tooltip: "Inspection Setup",
				icon: "check-square",
				link: PATH_ASSET_SENTINEL_FLEET_INSPECTION_SETUP,
				permission: { area: "fleet", key: "Inspections Setup" },
			},
			{
				label: "Funding Source",
				tooltip: "Funding Source",
				icon: "wallet",
				link: PATH_ASSET_SENTINEL_FLEET_FUNDING_SOURCES,
				permission: { area: "modules", key: "Funding Sources" },
			},
			// {
			// 	label: "Code Maintenance",
			// 	tooltip: "Code Maintenance",
			// 	icon: "cog",
			// 	link: PATH_ASSET_SENTINEL_FLEET_CODE_MAINTENANCE,
			// 	permission: { area: "fleet", key: "Code Maintenance" },
			// },
		],
	},
	{
		label: "Equipment",
		tooltip: "Equipment",
		link: PATH_ASSET_SENTINEL_EQUIPMENT_DASHBOARD,
		isAssetSentinelModule: true,
		icon: "toolbox",
		permission: { area: "modules", key: "Equipment" },
		subMenu: [
			{
				label: "Dashboard",
				tooltip: "Dashboard",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_DASHBOARD,
				icon: "home",
				alwaysVisible: true,
				// permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Equipment",
				tooltip: "Equipment",
				link: PATH_ASSET_SENTINEL_EQUIPMENT,
				icon: "toolbox",
				permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Maintenance",
				tooltip: "Maintenance",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_MAINTENANCE,
				icon: "tools",
				permission: { area: "equipment", key: "Maintenance" },
			},
			{
				label: "Dispensable Items",
				tooltip: "Dispensable Items",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_DISPENSABLE_ITEMS,
				icon: "box",
				permission: { area: "equipment", key: "Dispensable Items" },
			},
			{
				label: "Funding Source",
				tooltip: "Funding Source",
				icon: "wallet",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_FUNDING_SOURCES,
				permission: { area: "modules", key: "Funding Sources" },
			},
			// {
			// 	label: "Code Maintenance",
			// 	tooltip: "Code Maintenance",
			// 	icon: "cog",
			// 	link: PATH_ASSET_SENTINEL_EQUIPMENT_CODE_MAINTENANCE,
			// 	permission: { area: "equipment", key: "Code Maintenance" },
			// },
		],
	},
];

const menuSettings = [
	{
		label: "Home",
		tooltip: "Home",
		link: PATH_HOME,
		icon: "home",
		alwaysVisible: true,
	},
	{
		label: "Applicants",
		tooltip: "Applicants",
		link: PATH_APPLICANTS,
		icon: "user-friends",
		permission: { area: "modules", key: "Applicants" },
	},
	{
		label: "Employees",
		tooltip: "Employees",
		link: PATH_EMPLOYEE,
		icon: "users",
		permission: { area: "modules", key: "Employees" },
	},
	{
		label: "Training",
		tooltip: "Training",
		link: PATH_TRAINING_COURSES,
		icon: "user-graduate",
		permission: { area: "modules", key: "Training" },
		subMenu: [
			{
				label: "Courses",
				tooltip: "Courses",
				link: PATH_TRAINING_COURSES,
				permission: { area: "training", key: "Courses" },
			},
			{
				label: "Training Records",
				tooltip: "Training Records",
				link: PATH_TRAINING_PARTICIPANTS,
				permission: { area: "training", key: "Participants" },
			},
			{
				label: "Certifications",
				tooltip: "Certifications",
				link: PATH_TRAINING_CERTIFICATIONS,
				permission: { area: "training", key: "Certifications" },
			},
			{
				label: "Mass Update Training Records",
				tooltip: "Mass Update Training Records",
				link: PATH_TRAINING_MASS_UPDATE,
				permission: { area: "training", key: "Mass Update" },
			},
			{
				label: "Training Summary",
				tooltip: "Training Summary",
				link: PATH_TRAINING_SUMMARY,
				permission: { area: "training", key: "Summary" },
			},
		],
	},
	{
		label: "Fleet",
		tooltip: "Fleet",
		link: PATH_ASSET_SENTINEL_FLEET_DASHBOARD,
		icon: "truck",
		isAssetSentinelModule: true,
		permission: { area: "modules", key: "Fleet" },
		subMenu: [
			{
				label: "Dashboard",
				tooltip: "Dashboard",
				link: PATH_ASSET_SENTINEL_FLEET_DASHBOARD,
				icon: "home",
				alwaysVisible: true,
				// permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Fleet Vehicles",
				tooltip: "Fleet Vehicles",
				icon: "car",
				link: PATH_ASSET_SENTINEL_FLEET_VEHICLES,
				permission: { area: "fleet", key: "Vehicles" },
			},
			{
				label: "Work Orders",
				tooltip: "Work Orders",
				icon: "wrench",
				link: PATH_ASSET_SENTINEL_FLEET_WORK_ORDERS,
				permission: { area: "fleet", key: "Work Orders" },
			},
			{
				label: "Inspections",
				tooltip: "Inspections",
				icon: "check-circle",
				link: PATH_ASSET_SENTINEL_FLEET_INSPECTION,
				permission: { area: "fleet", key: "Inspections" },
			},
			{
				label: "Inspection Setup",
				tooltip: "Inspection Setup",
				icon: "check-square",
				link: PATH_ASSET_SENTINEL_FLEET_INSPECTION_SETUP,
				permission: { area: "fleet", key: "Inspections Setup" },
			},
			{
				label: "Funding Source",
				tooltip: "Funding Source",
				icon: "wallet",
				link: PATH_ASSET_SENTINEL_FLEET_FUNDING_SOURCES,
				permission: { area: "modules", key: "Funding Sources" },
			},
			// {
			// 	label: "Code Maintenance",
			// 	tooltip: "Code Maintenance",
			// 	icon: "cog",
			// 	link: PATH_ASSET_SENTINEL_FLEET_CODE_MAINTENANCE,
			// 	permission: { area: "fleet", key: "Code Maintenance" },
			// },
		],
	},
	{
		label: "Equipment",
		tooltip: "Equipment",
		link: PATH_ASSET_SENTINEL_EQUIPMENT_DASHBOARD,
		isAssetSentinelModule: true,
		icon: "toolbox",
		permission: { area: "modules", key: "Equipment" },
		subMenu: [
			{
				label: "Dashboard",
				tooltip: "Dashboard",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_DASHBOARD,
				icon: "home",
				alwaysVisible: true,
				// permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Equipment",
				tooltip: "Equipment",
				link: PATH_ASSET_SENTINEL_EQUIPMENT,
				icon: "toolbox",
				permission: { area: "equipment", key: "Equipment" },
			},
			{
				label: "Maintenance",
				tooltip: "Maintenance",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_MAINTENANCE,
				icon: "tools",
				permission: { area: "equipment", key: "Maintenance" },
			},
			{
				label: "Dispensable Items",
				tooltip: "Dispensable Items",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_DISPENSABLE_ITEMS,
				icon: "box",
				permission: { area: "equipment", key: "Dispensable Items" },
			},
			{
				label: "Funding Source",
				tooltip: "Funding Source",
				icon: "wallet",
				link: PATH_ASSET_SENTINEL_EQUIPMENT_FUNDING_SOURCES,
				permission: { area: "modules", key: "Funding Sources" },
			},
			// {
			// 	label: "Code Maintenance",
			// 	tooltip: "Code Maintenance",
			// 	icon: "cog",
			// 	link: PATH_ASSET_SENTINEL_EQUIPMENT_CODE_MAINTENANCE,
			// 	permission: { area: "equipment", key: "Code Maintenance" },
			// },
		],
	},
];

export default menuSettings;
